import gql from "graphql-tag";

const NAVSLOTS_QUERY = gql`  
  query NavSlots {
    navigations{
    id
    name
    description
    slug
    menu{
      id
      name
      description
      items{
        id
        label
        description
        uri
      }
    }
  }
  }
`;

export default NAVSLOTS_QUERY;